import { InjectionToken } from '@angular/core';
import { INativePreferences } from '@services/schema/interfaces/INativePreferences';

export const NATIVE_PREFERENCE_TOKEN = new InjectionToken<INativePreferences>('NativePreferencesProvider');
